import { END_POINTS } from "../constants/url";
import { Service } from "../types/General";

import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
  data: any;
};

export const ServicesApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getServices: builder.query<
      CommonResponseType,
      {
        id: string;
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ id, page, limit, search }) => ({
        url: `${END_POINTS.services}?subCategoryId=${id}&page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
      }),
    }),
    addServices: builder.mutation<CommonResponseType, { data: Service }>({
      query: (body) => ({
        url: END_POINTS.services,
        method: "POST",
        body: body?.data,
      }),
    }),
    updateServices: builder.mutation<
      CommonResponseType,
      { id: string; body: Service },
      {
        id: string;
      }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.services}/${id}`,
        method: "PUT",
        body: body,
      }),
    }),
    deleteServices: builder.query<
      CommonResponseType,
      { id: string },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.services}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});
export const {
  useLazyGetServicesQuery,
  useAddServicesMutation,
  useLazyDeleteServicesQuery,
  useUpdateServicesMutation,
} = ServicesApi;
